/*
 * alt-text-enforcer.js
 * -----------------------------------------------------------------------------
 * Guarantees that every <img> on the storefront has non-empty alt text.
 *
 *  - Images that ALREADY have alt text are left untouched (existing alt is kept).
 *  - Images with a missing or empty/whitespace-only alt get a default value.
 *  - Covers theme-rendered images, rich-text/content images (product & blog
 *    bodies, pages), and images injected later by AJAX, lazy-loading, quick-view
 *    modals, etc. via a MutationObserver.
 *
 * Configure the fallback via a global before this file loads, otherwise the
 * built-in default is used:
 *     window.ALT_TEXT_DEFAULT = 'Lambda Beauty Shoppes images';
 * -----------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var DEFAULT_ALT = (window.ALT_TEXT_DEFAULT || 'Lambda Beauty Shoppes images');

  // True when the image has no usable alt text (missing, empty, or whitespace).
  function needsAlt(img) {
    if (!img || img.tagName !== 'IMG') return false;
    if (!img.hasAttribute('alt')) return true;
    return img.getAttribute('alt').trim() === '';
  }

  // Apply the fallback only when needed; never overwrites real alt text.
  function enforce(img) {
    if (needsAlt(img)) {
      img.setAttribute('alt', DEFAULT_ALT);
    }
  }

  // Initial sweep over everything already in the DOM.
  function sweep(root) {
    var imgs = (root || document).querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) enforce(imgs[i]);
  }

  // Watch for images added later (AJAX, lazyload, modals) and for alt
  // attributes that get cleared/replaced with an empty value at runtime.
  function observe() {
    if (typeof MutationObserver === 'undefined') return;
    var mo = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var mut = mutations[m];

        if (mut.type === 'attributes' && mut.target.tagName === 'IMG') {
          enforce(mut.target);
          continue;
        }

        for (var n = 0; n < mut.addedNodes.length; n++) {
          var node = mut.addedNodes[n];
          if (node.nodeType !== 1) continue;          // elements only
          if (node.tagName === 'IMG') {
            enforce(node);
          } else if (node.querySelectorAll) {
            sweep(node);                              // catch nested imgs
          }
        }
      }
    });

    mo.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['alt']
    });
  }

  function init() {
    sweep(document);
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
